import type { Transport } from '@sveltejs/kit'
import { Ratio } from '$lib/ratio'

/**
 * Types that cross from server load data to the browser: the protocol snapshot's prices
 * and market ratios. Hooks load on every page, so nothing heavy belongs here; the
 * snapshot's UTxOs travel as CBOR instead (see `ProtocolSnapshotWire`).
 */
export const transport: Transport = {
  Ratio: {
    encode: (value) => value instanceof Ratio && [value.numerator, value.denominator],
    decode: ([numerator, denominator]: [bigint, bigint]) => new Ratio(numerator, denominator),
  },
}
